import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/del_sniff.png'
import _imports_1 from '@/assets/image/icon/upload_add.png'
import _imports_2 from '@/assets/image/icon/floatrate/edit.png'


const _withScopeId = n => (_pushScopeId("data-v-3f80cc14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-addition" }
const _hoisted_2 = { class: "shop-addition-info" }
const _hoisted_3 = { class: "title mb_5" }
const _hoisted_4 = { class: "flex-ter title-h1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "greenDot" }, null, -1))
const _hoisted_6 = { class: "mt_5 title-tip" }
const _hoisted_7 = { class: "flex mb_30" }
const _hoisted_8 = { class: "all-addition rel" }
const _hoisted_9 = { class: "title mb_10" }
const _hoisted_10 = {
  key: 0,
  class: "add-data line--3"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "add-data line--3" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "title mb_5" }
const _hoisted_15 = { class: "flex-ter title-h1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "greenDot" }, null, -1))
const _hoisted_17 = { class: "mt_5 title-tip" }
const _hoisted_18 = { class: "flex-wrap mb_30" }
const _hoisted_19 = { class: "flex title" }
const _hoisted_20 = { class: "fx-1 line--2 upBlock flex-ter" }
const _hoisted_21 = { class: "fx-1 line--3" }
const _hoisted_22 = {
  key: 0,
  class: "error-text"
}
const _hoisted_23 = { class: "add-data downBlock" }
const _hoisted_24 = { class: "line--2" }
const _hoisted_25 = { class: "action" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"height":"11px","width":"10px"}
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "title mb_10" }
const _hoisted_33 = { class: "flex-ter title-h1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "greenDot" }, null, -1))
const _hoisted_35 = { class: "flex-ter gap-4" }
const _hoisted_36 = {
  key: 0,
  class: "abs",
  style: {"top":"0","left":"0","background":"#000","color":"#fff","padding":"5px 12px","border-radius":"0 4px 4px 4px"}
}
const _hoisted_37 = {
  class: "pl-10 pr-10 flex-center",
  style: {"height":"50px","padding":"0 8px"}
}
const _hoisted_38 = { class: "line--2" }
const _hoisted_39 = { class: "edit-wash-btn" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_42 = ["src"]

import { t } from '@/plugins/i18n'
import AdtCfg from '@/components/additional/AdtCfg.vue'
import WashingMark from '@/components/additional/WashingMark.vue'
import { AdtCfgList, deleteAdtCfg, getWashingMarkList } from '@/apis/setup'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import ShopAdditionGroup from './ShopAdditionGroup.vue'
import { ref, computed, watch } from 'vue'
import { confirmDelAdtCfg } from '@/util/useConfirm'
import { ElMessage } from 'element-plus'
import { isD2C, isJA, isKO } from '@/store'
import { useStore } from 'vuex'
import WashingMarkPreview from '@/components/additional/WashingMarkPreview.vue'
import bus from '@/util/useBus'
import { ShopType } from '@/common/const'

// 获取组件默认国家商品

export default /*#__PURE__*/_defineComponent({
  props: ['sourceCountry'],
  async setup(__props) {

let __temp: any, __restore: any

const props = __props

console.log(props, 'props');

const nameKey = ref(isJA() ? 'categoryCateNameJp' : isKO() ? 'categoryCateNameKr' : 'categoryCateNameEn')
const myAddCfgs: any = ref([])
const defCfg: any = ref(null)
const hasMap: any = ref({})
const store = useStore()
/** 当前店铺 */
const curShop = store.getters.curShop
/** 当前店铺信息的仓库配置 */
const warehouseCodeList = computed(() => {
  return store.getters.user.customerShopList.find((item: any) => item.customerShopId === curShop)?.warehouseList
})

/** 当前店铺信息的仓库配置（去对应配置下的warehouseCode） */
const warehouseCode = computed(() => {
  return warehouseCodeList.value?.find((item) => item.warehouseCountry === props.sourceCountry)?.warehouseCode
})
const update = () => {
  const has: any = {}
  //   需要加个入参，区分韩国商品还是中国商品
  AdtCfgList({ warehouseCode: warehouseCode.value }).then((res) => {
    if (res.success) {
      const arr: any = []
      res.data.forEach((v: any) => {
        if (v.additionScene === 1 && v.categoryAdditionList) {
          arr.push(v)
          v.categoryAdditionList = v.categoryAdditionList.filter(
            (v: any) => v.categoryStaus
          )
          if (!v.categoryAdditionList.length) {
            v.disabled = true
          }
          v.categoryAdditionList.forEach((v2: any) => {
            has[v2.categoryCateId] = true
          })
        }
        // else if (v.additionScene === 0) {
        //   defCfg.value = v
        // }
      })
      //   直接在外面，不理解为啥放在循环里面
      const defCfgVal = res.data?.find((item) => item.additionScene === 0)
      defCfg.value = defCfgVal
      myAddCfgs.value = arr
      hasMap.value = has
    }
  })
}

;(
  ([__temp,__restore] = _withAsyncContext(() => update())),
  await __temp,
  __restore()
)
// 监听变化重新请求
watch(() => props.sourceCountry, () => {
  update()
})

const additionScene: any = ref(0)
const editIcon = require('@/assets/image/icon/floatrate/edit.png')
const openPanel = (c: any, f: boolean, type: any) => {
  additionScene.value = type
  cfg.value = c
  forCate.value = f
  if (!c && myAddCfgs.value.length > 10) {
    ElMessage.error(t('类目附加项配置不能超过10个'))
    return
  }
  visible.value = true
}

const delCfg = (v: any) => {
  confirmDelAdtCfg(
    () => {
      deleteAdtCfg({ shopAdditionId: v.shopAdditionId }).then(update)
    },
    () => { }
  )
}

const visible = ref(false)
const washingVisible = ref(false)
const washData = ref({})

const forCate = ref(true)

const cfg = ref(null)

const sweninIcon = require('@/assets/image/icon/swenin.png')

const sweninList = ref<any[]>([])
const updateWashingMark = () => {
  getWashingMarkList().then((res) => {
    sweninList.value = res.data
  })
}
updateWashingMark()
bus.on('updateWashMark', () => {
  updateWashingMark()
})
const openWashingMark = (data: any) => {
  washData.value = data.washedlabelAdditionId ? data : {}
  washingVisible.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_unref(t)('我的默认附加项')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('使用类目')) + "：" + _toDisplayString(_unref(t)('全部')), 1),
          (defCfg.value && defCfg.value?.additionItemList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(defCfg.value.additionItemList.map((v) => v.additionNameJp).join('，')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(defCfg.value?.noAdditionalFlag ? _unref(t)('不需要检品') : _unref(t)('请选择商品附加项')), 1)
              ])),
          _createElementVNode("div", {
            class: "abs a-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openPanel(defCfg.value, false, 0)))
          }, [
            _createElementVNode("img", {
              src: _unref(editIcon),
              alt: ""
            }, null, 8, _hoisted_13),
            _createTextVNode(" " + _toDisplayString(_unref(t)('打开全部')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_unref(t)('我的类目附加项')), 1)
        ]),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('当您订单下有该类目商品时，我们将默认为您添加以下附加服务')), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myAddCfgs.value, (v, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass(["add-cfg rel", { disabled: v.disabled }])
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(_unref(t)('使用类目')) + "：", 1),
                _createElementVNode("span", _hoisted_21, _toDisplayString(v.categoryAdditionList.map((v) => v[nameKey.value]).join('，')), 1)
              ]),
              (v.disabled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(t)('类目失效')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(v.additionItemList.map((v) => v.additionNameJp).join('，')), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              (!v.disabled)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "a-btn openPanel open-all-btn",
                    onClick: ($event: any) => (openPanel(v, true, 1))
                  }, [
                    _createElementVNode("img", {
                      src: _unref(editIcon),
                      alt: ""
                    }, null, 8, _hoisted_27),
                    _createTextVNode(_toDisplayString(_unref(t)('打开全部')), 1)
                  ], 8, _hoisted_26))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "btn error-btn",
                onClick: ($event: any) => (delCfg(v))
              }, [
                _hoisted_29,
                _createTextVNode(" " + _toDisplayString(_unref(t)('删除')), 1)
              ], 8, _hoisted_28)
            ])
          ], 2))
        }), 128)),
        _createElementVNode("div", {
          class: "add-cfg-btn flex-center btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openPanel(null, true, 1)))
        }, _hoisted_31)
      ]),
      _createVNode(ShopAdditionGroup, {
        countryCode: props.sourceCountry,
        warehouseCode: _unref(warehouseCode),
        key: props.sourceCountry
      }, null, 8, ["countryCode", "warehouseCode"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createTextVNode(_toDisplayString(_unref(t)('水洗标信息配置')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sweninList.value, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "rel wash-o",
          key: v.shopAddressWashedlabelId
        }, [
          _createVNode(WashingMarkPreview, {
            style: {"height":"100px"},
            washData: v
          }, null, 8, ["washData"]),
          (v.isDefault && !_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_unref(t)('默认')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(v.washedlabelName), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", {
              onClick: ($event: any) => (openWashingMark(v)),
              class: "cursor-pt"
            }, [
              _hoisted_41,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('编辑')), 1)
            ], 8, _hoisted_40)
          ])
        ]))
      }), 128)),
      (sweninList.value.length < (_unref(isD2C)() ? 1 : 3))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "swenin flex-center-col rel cursor-pt",
            onClick: openWashingMark
          }, [
            _createElementVNode("img", {
              referrerPolicy: "no-referrer",
              src: _unref(sweninIcon),
              alt: ""
            }, null, 8, _hoisted_42),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('配置品牌专属水洗标')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              countryCode: props.sourceCountry,
              warehouseCode: _unref(warehouseCode),
              forCate: forCate.value,
              cfg: cfg.value,
              "has-map": hasMap.value,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
              onUpdate: update,
              additionScene: additionScene.value,
              type: "AdtCfg",
              title: _unref(t)('编辑类目附加项')
            }, null, 8, ["countryCode", "warehouseCode", "forCate", "cfg", "has-map", "additionScene", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (washingVisible.value)
          ? (_openBlock(), _createBlock(WashingMark, {
              key: 0,
              "wash-data": washData.value,
              first: sweninList.value.length <= 0,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (washingVisible.value = false))
            }, null, 8, ["wash-data", "first"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ]))
}
}

})